
<div class="wysiwyg-editor">
    <div v-if="!externalTooltip && !alwaysShowToolbar" :id="toolbarContainerId" class="formatting-panel" ref="formattingPanel" style="display: none;"></div>
    <div class="froala-input" :class="{compress: compress}">
      <div class="editor inline-editor" v-bind="$attrs">
        <froala :tag="tag" ref="editor" v-model.sync="localValue" :id="id" :config="config" class="inline-editor"></froala>
      </div>
      <div v-if="!externalTooltip && alwaysShowToolbar" :id="toolbarContainerId" class="formatting-panel-bottom inline-formatting-panel"></div>
      <context-menu ref="contextMenu"
                    :state="modalStateFor(vueModalID.dynamicContentPopup)"
                    :index="vueModalID.dynamicContentPopup"
                    fixed
                    @close="closeDynamicContentPopup">
        <component v-for="(options, index) in dynamicOptions" :is="options.is" @select="insertDynamicReference"
                   :key="`dynamic-option-${options.title}-${index}`"
                   v-bind="options.props">
          <template #heading>
            <h4 class="popup-title">{{options.title}}</h4>
          </template>
        </component>
      </context-menu>
    </div>
</div>
